import { useState } from 'react'

import Facet from './Facet'
import type { ActiveFiltersProps, FacetsProps } from '../../shared/Module'

interface FiltersComponentProps {
  activeFilters: ActiveFiltersProps
  facets: FacetsProps
  clearFilters: Function
  deleteFilter: Function
  modal?: boolean
  prefix?: string
  selectFilter: Function
}

const REGEX_NUMERIC_VALUE = /^(\d+(?:\.\d+)?)(?:([mcd]?m|gr?)\.?)?$/i

const SIZE_FACTORS: { [key: string]: number } = {
  mm: 1,
  cm: 10,
  dm: 100,
  m: 1000,
}

export function compareNumeric(a: string, b: string) {
  let [, aSize, aUnit] = REGEX_NUMERIC_VALUE.exec(a) || []
  let [, bSize, bUnit] = REGEX_NUMERIC_VALUE.exec(b) || []
  const aSizeRes = parseFloat(aSize) * (SIZE_FACTORS[aUnit] || 1)
  const bSizeRed = parseFloat(bSize) * (SIZE_FACTORS[bUnit] || 1)
  return Math.sign(aSizeRes - bSizeRed)
}

const SORTER = new Intl.Collator('fr-FR', {
  numeric: true,
  ignorePunctuation: true,
})

// TODO: gérer les filters par tranches tarifaires
const Filters = ({
  activeFilters,
  deleteFilter,
  facets,
  modal = false,
  prefix,
  selectFilter,
}: FiltersComponentProps) => {
  const sortedFacets = facets.map((facet) => {
    if (facet.unsorted) {
      return facet
    }

    // Separate numeric from non numeric filters to apply the right sorting method
    const numericFilters = facet.filters
      .filter(({ label }) => REGEX_NUMERIC_VALUE.test(label))
      .sort(({ label: label1 }, { label: label2 }) =>
        compareNumeric(label1, label2)
      )

    const nonNumericFilters = facet.filters
      .filter((filter) => !numericFilters.includes(filter))
      .sort(({ label: label1 }, { label: label2 }) =>
        SORTER.compare(label1, label2)
      )

    return {
      ...facet,
      filters: [...numericFilters, ...nonNumericFilters],
    }
  })

  const [expanded, setExpanded] = useState('')

  return (
    <form className='c-filter' action='#'>
      {/* <div className='c-filter__title' role='heading' aria-level={2}>
        Filtres
      </div> */}
      {sortedFacets.map(({ id, paramKey, title, filters }) => (
        <Facet
          activeFilters={activeFilters[id]}
          expanded={expanded === id}
          filters={filters}
          id={id}
          key={id}
          modal={modal}
          onClick={toggleFacet}
          onFilterDelete={deleteFilter}
          onFilterSelect={selectFilter}
          paramKey={paramKey}
          prefix={prefix}
          title={title}
        />
      ))}
    </form>
  )

  function toggleFacet(id: string) {
    setExpanded(expanded === id ? '' : id)
  }
}

export default Filters
